import { useTranslation } from 'react-i18next';
import React, { FC } from 'react';
import { Link } from '@digdir/designsystemet-react';

import { useUser } from '../../../hooks/useUser';
import { BuildingScreenTab, camelCasify } from '../../../utils/navigation';

import { MenuItemSpan, StyledNavLink } from './styledComponents';

export interface TitleProps {
  tab: BuildingScreenTab;
}

export const SideMenuButton: FC<TitleProps> = ({ tab }) => {
  const { t } = useTranslation();
  const { user } = useUser();

  const buttonText = t(`buildingScreen.tab.${camelCasify(tab)}.tabTitle`, {
    context: user?.type
  });

  return (
    <Link asChild>
      <StyledNavLink to={tab} aria-label={buttonText}>
        {({ isActive }) => <MenuItemSpan isActive={isActive}>{buttonText}</MenuItemSpan>}
      </StyledNavLink>
    </Link>
  );
};
